import { useEffect, useState } from 'react';
import { CATALOG_STATS } from '../data/dummyCatalog';
import { searchCruisesFromCatalog } from '../utils/catalogSearch';

export function useCruiseSearch(params, { enabled = true } = {}) {
  const [loading, setLoading] = useState(enabled);
  const [results, setResults] = useState([]);
  const [error, setError] = useState(null);
  const [catalogInfo, setCatalogInfo] = useState(null);

  const paramKey = JSON.stringify(params);

  useEffect(() => {
    if (!enabled) {
      setLoading(false);
      setResults([]);
      setError(null);
      setCatalogInfo(null);
      return undefined;
    }

    let cancelled = false;

    async function load() {
      setLoading(true);
      setError(null);

      try {
        const data = searchCruisesFromCatalog(params, 80);
        if (!cancelled) {
          setResults(data);
          setCatalogInfo(`${CATALOG_STATS.cruises.toLocaleString()}+ cruises in catalog`);
        }
      } catch (err) {
        if (!cancelled) {
          setResults([]);
          setError(err.message || 'Cruise search failed');
        }
      } finally {
        if (!cancelled) setLoading(false);
      }
    }

    load();
    return () => {
      cancelled = true;
    };
  }, [paramKey, enabled]);

  return { loading, results, error, catalogInfo };
}
